//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

let token = localStorage.getItem("token-admin")
import LembarNodin from '@/components/admin/LembarNodin.vue'
import moment from 'moment'

export default {
  name: 'DetailPermohonan',
  components:{LembarNodin},
  data:function(){
    return{
      current: 1,
      sumPage: 10,
      listinfo: null,
      info: {},
      id: '',


      reqby: {},
      tabrespon: 'jawab', nodinView : false, nodin: {description: ''},
      answer:{directAnswer:''},
      statusOption:[{label:'Dapat Diberikan', value: 1},{label:'Tidak Dapat Diberikan', value: 2},{label:'Ditolak', value: 3}],
      formatOption:['Softcopy', 'Hardcopy'], fomratfile: 'Softcopy',

      memolist: [], historylist: [], answerlist: [],

      sentTo: null, positionOpt: [], selectedNodin: '',
      editorSetting: [
              [ {
                  label: this.$q.lang.editor.align,
                  icon: this.$q.iconSet.editor.align,
                  fixedLabel: true,
                  list: 'only-icons',
                  options: ['left', 'center', 'right', 'justify']
                },],
                [ {
                  label: 'Text',
                  fixedLabel: true,
                  list: 'only-icons',
                  options: ['bold', 'italic', 'strike', 'underline', 'subscript', 'superscript']
                },],
              ['hr', 'link'],
              ['undo', 'redo'],
              ['print', 'fullscreen'],],

    }
  },
  mounted(){
    var val = '%25'; var search = '%25'
    this.id = this.$route.params.id
    this.answer.t_info_objection_id = this.id 
    this.fetch()
  },
  methods:{
    fetch(){
    this.$http.get('/nodin_byobjectionid/'+this.id, {
        headers: { Authorization: "Bearer " + token}
      })
      .then (result => {
        this.memolist = result.data
      })

    this.$http.get('/obj_byid/'+ this.id, {
      headers: { Authorization: "Bearer " + token}
      })
      .then (result => {
        this.info = result.data
      })

      this.$http.get('/position', {
        headers: { Authorization: "Bearer " + token}
        })
        .then (result => {
          for(var i = 0; i < result.data.length; i++){
            this.positionOpt.push({label: result.data[i].position, value: result.data[i].id})
          }
        })

      this.$http.get('/answer_by_objectionid/'+this.id, {
      headers: { Authorization: "Bearer " + token}
      })
      .then (result => {
        this.answerlist = result.data
      })

    
    this.$http.get('/history_by_objectionid/'+this.id, {
      headers: { Authorization: "Bearer " + token}
      })
      .then (result => {
        this.historylist = result.data
      })

    },
    formNodin(){
      console.log(moment().locale())

      this.nodinView = true
      this.nodin.reference_id = this.id
      this.nodin.reference_type = 'keberatan'
      this.nodin.about = 'Permohonan Rekomendasi Jawaban Atas Keberatan Pengajuan Informasi Publik'
      this.nodin.description = 
          'Sehubungan dengan adanya pengajuan keberatan tertanggal '+ moment(this.info.createdDate).format('DD MMMM YYYY') 
          +' terkait permohonan informasi nomor ' +this.info.requestNumber+ ' atas nama ' +this.info.name 
          +' dengan alasan: '+this.info.objection_reason
          +' <div><br/></div> Adapun rekomendasi jawaban mohon dapat kami terima sebelum tanggal ' 
          +moment(this.info.deadline).format('DD MMMM YYYY')+ ' agar dapat memenuhi mekanisme jangka waktu penyelesaian permintaan informasi publik (10 hari kerja) yang telah diatur dalam Pasal 22 Ayat (7) UU No. 14 Tahun 2008 tentang keterbukaan Informasi Publik.<div><br></div><div>Atas perhatian dan kerjasama Saudara, kami ucapkan terima kasih.</div>'
    },
    addNodin(){
      this.nodin.t_position_id = this.$store.state.currentAdmin.id
      this.nodin.description = this.nodin.description.replace(/"/g,'\'')
      
      this.$http.post('/new_memo/', this.nodin, {
        headers: { Authorization: "Bearer " + token}
      })
      .then (async result => {
        var id = await result.data
        
        let rcvNodin = {}
        rcvNodin.t_memo_id = id
        rcvNodin.t_position_id = this.sentTo
        rcvNodin.memoReference = null
        rcvNodin.createdBy =  this.$store.state.currentAdmin.username
        this.$http.post('/new_memo_receiver/', rcvNodin, {
          headers: { Authorization: "Bearer " + token}
        })
        .then (result => {
          this.fetch()
          this.nodinView = false

          this.$q.notify({
            icon: "done",
            color: "positive",
            message: "Draft nota dinas tersimpan",
          });
        })

      })
    },
    submitAnswer(){
      this.answer.directAnswer = this.answer.directAnswer.replace(/"/g,'\'')
      this.answer.createdBy = this.$store.state.currentAdmin.username
      this.$http.post('/new_obj_answer', this.answer, {
        headers: { Authorization: "Bearer " + token}
      })
      .then (result => {
        this.$router.go('/')
        this.tabrespon = 'jawaban'
      })
    }
    
    
  }
}
